import { useAccountContext } from 'features/auth';
import { useLogoutMutation } from 'features/graphql';
import { Container, Navbar, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import Image from '../../logo.svg';
import {
  BoxArrowRight,
  FileEarmarkText,
  Collection,
  CurrencyYen,
  Circle,
  ChevronDown,
  ChevronUp,
  ZoomIn,
  ZoomOut,
} from 'react-bootstrap-icons';
import { DRAFT_QUOTATIONS_PATH, PRICE_SHOW_PATH, QUOTATIONS_PATH } from 'route/paths';
import { useState } from 'react';
import { useZoom } from 'hooks/ZoomContext';

export const TopBar = () => {
  const accountContext = useAccountContext();
  const [logoutMutation] = useLogoutMutation();
  const [isNoticeExpanded, setIsNoticeExpanded] = useState(true);
  const location = useLocation();
  const { zoomLevel, minZoom, maxZoom, handleZoomIn, handleZoomOut, handleZoomReset } = useZoom();

  const onLogout = () => {
    accountContext.logouted();
    logoutMutation();
  };

  const toggleNotice = () => {
    setIsNoticeExpanded(!isNoticeExpanded);
  };

  const isPriceShowPage = location.pathname === PRICE_SHOW_PATH;

  if (!accountContext.isLoggedIn()) {
    return null;
  }

  const MyPriceIcon = () => {
    return (
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Circle size={24} color="green" />
        <CurrencyYen
          size={16}
          color="green"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -35%)',
          }}
        />
      </div>
    );
  };

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 100 }}>
      <Navbar className="notice">
        <Container fluid="xl">
          <div className="d-flex w-100 align-items-center">
            <div
              className={`py-0 text-white text-break ${isNoticeExpanded ? '' : 'text-truncate'}`}
              style={{ flex: 1 }}
            >
              {accountContext.account?.notice.notice}
            </div>
            <button
              className="btn btn-sm text-white ms-2"
              onClick={toggleNotice}
              aria-label={isNoticeExpanded ? '折りたたむ' : '展開する'}
              title={isNoticeExpanded ? '折りたたむ' : '展開する'}
            >
              {isNoticeExpanded ? <ChevronUp /> : <ChevronDown />}
            </button>
          </div>
        </Container>
      </Navbar>

      <Navbar className="header">
        <Container fluid="xl">
          <div className="navbar-brand">
            <Link className="" to={PRICE_SHOW_PATH}>
              <img src={Image} alt="Logo" style={{ height: 35 }} />
            </Link>

            <Link className="btn ms-5 menu" to={PRICE_SHOW_PATH}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <MyPriceIcon />
                <span className="">価格表</span>
              </div>
            </Link>

            <Link className="btn ms-3 menu" to={DRAFT_QUOTATIONS_PATH}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <FileEarmarkText className="fs-4" />
                <span className="">見積依頼</span>
              </div>
            </Link>
            <Link className="btn ms-3 menu" to={QUOTATIONS_PATH}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <Collection className="fs-4" />
                <span className="">依頼履歴</span>
              </div>
            </Link>
          </div>

          <div className="navbar">
            <div className="me-2 text-nowrap ">ようこそ：{accountContext.accountDisplayName()}</div>

            {isPriceShowPage && (
              <div className="me-3 d-flex align-items-center gap-1">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleZoomOut}
                  disabled={zoomLevel <= minZoom}
                  title="縮小"
                  style={{ padding: '4px 8px' }}
                >
                  <ZoomOut size={16} />
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleZoomReset}
                  title="リセット"
                  style={{ padding: '4px 8px', minWidth: '50px' }}
                >
                  <small>{Math.round(zoomLevel * 125)}%</small>
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleZoomIn}
                  disabled={zoomLevel >= maxZoom}
                  title="拡大"
                  style={{ padding: '4px 8px' }}
                >
                  <ZoomIn size={16} />
                </Button>
              </div>
            )}

            <button className="btn text-success" onClick={() => onLogout()}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <BoxArrowRight className="fs-5" />
                <small>ログアウト</small>
              </div>
            </button>
          </div>
        </Container>
      </Navbar>
    </div>
  );
};
